export * from './new_tab_icon';
